// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"153":"0ddf9ced","218":"26be8307","745":"9fb1f083","871":"024593fb","883":"8a2b0fa8"}[chunkId] + ".chunk.css";
};